// extracted by mini-css-extract-plugin
export var absolute = "counter-dot-module--absolute--fDwV1";
export var wrapper = "counter-dot-module--wrapper--FAqaW";